import { render, staticRenderFns } from "./DiplomaClassSave.vue?vue&type=template&id=865fb6ca&"
import script from "./DiplomaClassSave.vue?vue&type=script&lang=js&"
export * from "./DiplomaClassSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports